import { render, staticRenderFns } from "./royalty-detail.vue?vue&type=template&id=2c37b6e8&scoped=true"
import script from "./royalty-detail.vue?vue&type=script&lang=js"
export * from "./royalty-detail.vue?vue&type=script&lang=js"
import style0 from "./royalty-detail.vue?vue&type=style&index=0&id=2c37b6e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c37b6e8",
  null
  
)

export default component.exports